<div class="main-container d-flex flex-column h-100" [class.paddingLeft]="isSidebarExpanded && role!=enumRole.PROVIDER">
    <!-- Single row: text left, buttons right -->
    <div class="d-flex justify-content-between align-items-center flex-wrap">
        <!-- Left side: heading and subtitle -->
        <div class="d-flex flex-column gap-2">
            <p class="fs-16 fw-500 mb-2 mb-sm-0">Manage Network ({{length}})</p>
            <span class="text-muted small">Add medical evidence providers and insurance agents</span>
        </div>

        <!-- Right side: buttons -->
        <div class="d-flex gap-2 align-items-center">
            <div class="d-flex flex-wrap me-3">
                <div class="mt-2 fs-12">
                    Filters By : &nbsp;&nbsp;&nbsp;&nbsp;
                </div>

                 <div class="filters">
                    <button class="filter-btn all" [ngClass]="{ active: selectedFilter === 'all' }"
                        (click)="selectState('all')">All</button>

                    <button class="filter-btn active-filter" [ngClass]="{ active: selectedFilter === 'active' }"
                        (click)="selectState('active')">Active</button>

                    <button class="filter-btn inactive-filter" [ngClass]="{ active: selectedFilter === 'inactive' }"
                        (click)="selectState('inactive')">Deactivated</button>
                </div>


                <!-- <div class="quantum-toggle-container" [class.is-active]="currentState === 'active'"
                    [class.is-inactive]="currentState === 'inactive'" [class.is-all]="currentState === 'all'">
                    <button class="toggle-button all-button" (click)="selectState('all')"
                        [class.selected]="currentState === 'all'">
                        <span class="label">All</span>
                        <div class="inner-shape"></div>
                    </button>

                    <button class="toggle-button active-button" (click)="selectState('active')"
                        [class.selected]="currentState === 'active'">
                        <span class="label">Active</span>
                        <div class="inner-shape"></div>
                    </button>

                    <button class="toggle-button inactive-button" (click)="selectState('inactive')"
                        [class.selected]="currentState === 'inactive'">
                        <span class="label">Deactive</span>
                        <div class="inner-shape"></div>
                    </button>
                </div> -->
            </div>
            <span class="cursor-pointer" (click)="onRefresh()" [ngClass]="{ 'rotate-animation': isRotating }"
                matTooltip="refresh" matTooltipPosition="above">
                <svg xmlns="http://www.w3.org/2000/svg" width="23" height="23" viewBox="0 0 24 24">
                    <g fill="none" stroke="#0075C9" stroke-linecap="round" stroke-width="1.2">
                        <path d="M6.446 10.512a5.75 5.75 0 0 0 8.429 6.468m2.679-3.492A5.75 5.75 0 0 0 9.125 7.02" />
                        <path stroke-linejoin="round" d="m3.75 12.5l2.5-2.5l2.5 2.5m6.5-1l2.5 2.5l2.5-2.5" />
                    </g>
                </svg>
            </span>

               <div class="controls" matTooltip="View mode" matTooltipPosition="above">
          <app-view-mode-toggle [currentViewMode]="viewMode" (viewModeChange)="changeViewMode($event)">
          </app-view-mode-toggle>
        </div>
            <div class="search-container" [class.expanded]="searchExpanded" [class.marginTop]="searchExpanded">
                <!-- Search Icon (always visible) -->
                <span class="search-icon" (click)="toggleSearch()" aria-label="Open search" *ngIf="!searchExpanded"
                    matTooltip="search" matTooltipPosition="above">
                    <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24">
                        <path fill="none" stroke="#0075C9" stroke-linecap="round" stroke-linejoin="round"
                            d="m21 21l-4.343-4.343m0 0A8 8 0 1 0 5.343 5.343a8 8 0 0 0 11.314 11.314"
                            stroke-width="2" />
                    </svg>
                </span>

                <!-- mat-form-field input + close icon, shown on expand -->
                <mat-form-field appearance="outline" class="search-field" *ngIf="searchExpanded">
                    <span matPrefix style="display: flex; align-items: center; margin-left: 8px;">
                        <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24" fill="none"
                            stroke="#0075C9" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round">
                            <path d="m21 21l-4.343-4.343m0 0A8 8 0 1 0 5.343 5.343a8 8 0 0 0 11.314 11.314" />
                        </svg>
                    </span>
                    <input matInput placeholder="Search" [(ngModel)]="searchQuery" (input)="onSearch()" />
                    <span (click)="toggleSearch()" class="cursor-pointer close-icon">
                        <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 24 24">
                            <path fill="none" stroke="#0075C9" stroke-linecap="round" stroke-width="1.5"
                                d="m8.464 15.535l7.072-7.07m-7.072 0l7.072 7.07" />
                        </svg>
                    </span>
                </mat-form-field>
            </div>
            <div class="action-boxes">
                <button class="primaryBtn" (click)="openAddAgent()">Add New Agent</button>
                <!-- <div class="action-box" (click)="openAddAgent()">
                    <div><svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 16 16">
                            <path fill="#66AEE0"
                                d="M8 15c-3.86 0-7-3.14-7-7s3.14-7 7-7s7 3.14 7 7s-3.14 7-7 7M8 2C4.69 2 2 4.69 2 8s2.69 6 6 6s6-2.69 6-6s-2.69-6-6-6" />
                            <path fill="#66AEE0"
                                d="M8 11.5c-.28 0-.5-.22-.5-.5V5c0-.28.22-.5.5-.5s.5.22.5.5v6c0 .28-.22.5-.5.5" />
                            <path fill="#66AEE0"
                                d="M11 8.5H5c-.28 0-.5-.22-.5-.5s.22-.5.5-.5h6c.28 0 .5.22.5.5s-.22.5-.5.5" />
                        </svg></div>
                    <div class="fs-12 fw-500" style="color:#0075C9">Add New Agent</div>
                </div>

                <div class="action-box" *ngIf="enumRole.INSURER == role" (click)="openAddProvider()">
                    <div><svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 16 16">
                            <path fill="#66AEE0"
                                d="M8 15c-3.86 0-7-3.14-7-7s3.14-7 7-7s7 3.14 7 7s-3.14 7-7 7M8 2C4.69 2 2 4.69 2 8s2.69 6 6 6s6-2.69 6-6s-2.69-6-6-6" />
                            <path fill="#66AEE0"
                                d="M8 11.5c-.28 0-.5-.22-.5-.5V5c0-.28.22-.5.5-.5s.5.22.5.5v6c0 .28-.22.5-.5.5" />
                            <path fill="#66AEE0"
                                d="M11 8.5H5c-.28 0-.5-.22-.5-.5s.22-.5.5-.5h6c.28 0 .5.22.5.5s-.22.5-.5.5" />
                        </svg></div>
                    <div class="fs-12 fw-500" style="color:#0075C9">Add New Provider</div>
                </div> -->
            </div>
<!-- 
            <div class="pagination-controls">
                Pages :
                <button class="pagination-button" (click)="previousPage()" [disabled]="currentPage === 1">
                    <svg viewBox="0 0 24 24" fill="currentColor" height="20" width="20">
                        <path d="M15.41 16.59L10.83 12l4.58-4.59L14 6l-6 6 6 6 1.41-1.41z"></path>
                    </svg>
                </button>
                <span class="fs-13">{{ currentPage }} / {{ totalPages }}</span>
                <button class="pagination-button" (click)="nextPage()" [disabled]="currentPage === totalPages">
                    <svg viewBox="0 0 24 24" fill="currentColor" height="20" width="20">
                        <path d="M8.59 16.59L13.17 12 8.59 7.41 10 6l6 6-6 6-1.41-1.41z"></path>
                    </svg>
                </button>
            </div> -->

        </div>
    </div>
    @if(viewMode==='grid'){

    <div class="custom-tab-wrapper" style="">

        <!-- <div class="filter-bar-row" *ngIf="enumRole.INSURER == role">
            <div class="pill-tabs">
                @if(enumRole.INSURER == role) {
                <button *ngFor="let tab of tabs; let i = index" (click)="handleTabClick(i)"
                    [class.active]="selectedTab === i">
                    {{ tab.label }}
                    <span class="count-chip" *ngIf="tab.count !== undefined">{{ tab.count }}</span>
                </button>
                }
                @else {
                <button (click)="handleTabClick(0)" [class.active]="selectedTab === 0">
                    Agents Added
                    <span class="count-chip">{{ agentsListTemp.length }}</span>
                </button>
                }
            </div>


            <div class="pagination-controls">
                Pages :
                <button class="pagination-button" (click)="previousPage()" [disabled]="currentPage === 1">
                    <svg viewBox="0 0 24 24" fill="currentColor" height="20" width="20">
                        <path d="M15.41 16.59L10.83 12l4.58-4.59L14 6l-6 6 6 6 1.41-1.41z"></path>
                    </svg>
                </button>
                <span class="page-info">{{ currentPage }} / {{ totalPages }}</span>
                <button class="pagination-button" (click)="nextPage()" [disabled]="currentPage === totalPages">
                    <svg viewBox="0 0 24 24" fill="currentColor" height="20" width="20">
                        <path d="M8.59 16.59L13.17 12 8.59 7.41 10 6l6 6-6 6-1.41-1.41z"></path>
                    </svg>
                </button>
            </div>

        </div> -->
        <div class="tab-content mt-3">
            <ng-container *ngIf="selectedTab === 0  || selectedTab === 1">
                @if(isDataLoading){
                <div class="loader-pro">
                    <app-loader></app-loader>
                </div>
                }
                @else {
                <ng-container *ngIf="agentsList && agentsList.length > 0;else noAgents">
                    <div class="table-container" [@listAnimation]
                        [ngStyle]="role === enumRole.PROVIDER ? {'margin-top': '1rem'} : {}">
                        <app-agent-card *ngFor="let agent of agentsList"  [role]="role" [agent]="agent"></app-agent-card>
                    </div>
                </ng-container>
                <ng-template #noAgents>
                    <div class="custom-card">
                        <app-no-data-found></app-no-data-found>
                    </div>
                </ng-template>
                }
            </ng-container>
            <ng-container *ngIf="selectedTab === 3">
                @if(isDataLoading){
                <div class="loader-pro">
                    <app-loader></app-loader>
                </div>
                }
                @else {
                <ng-container *ngIf="agentsList && agentsList.length > 0;else noProds">
                    <div class="provider-container" [@listAnimation]>
                        <app-provider-card *ngFor="let provider of agentsList"
                            [provider]="provider"></app-provider-card>
                    </div>
                </ng-container>
                <ng-template #noProds>
                    <div class="table-container">
                        <app-no-data-found></app-no-data-found>
                    </div>
                </ng-template>
                }
            </ng-container>
            <ng-container *ngIf="selectedTab === 2">
                @if(isDataLoading){
                <div class="loader-pro">
                    <app-loader></app-loader>
                </div>
                }
                @else {
                <ng-container *ngIf="distributorList && distributorList.length > 0;else noAgents">
                    <div class="table-container" [@listAnimation]
                        [ngStyle]="role === enumRole.DISTRIBUTOR ? {'margin-top': '1rem'} : {}">
                        <app-agent-card *ngFor="let distributors of distributorList" [role]="role" [agent]="distributors"></app-agent-card>
                    </div>
                </ng-container>
                <ng-template #noAgents>
                    <div class="custom-card">
                        <app-no-data-found></app-no-data-found>
                    </div>
                </ng-template>
                }
            </ng-container>
            
            <div class="pagination-controls">
                Pages :
                <!-- <button class="pagination-button" (click)="previousPage()" [disabled]="currentPage === 1">
                    <svg viewBox="0 0 24 24" fill="currentColor" height="20" width="20">
                        <path d="M15.41 16.59L10.83 12l4.58-4.59L14 6l-6 6 6 6 1.41-1.41z"></path>
                    </svg>
                </button> -->
                <button *ngFor="let page of [].constructor(totalPages); let i = index" (click)="goToPage(i + 1)"
                [ngClass]="{ 'active': currentPage === i + 1 }" class="pagination-btn">
                {{ i + 1 }} 
            </button>
                <!-- <span class="fs-13">{{ currentPage }} / {{ totalPages }}</span> -->
                <!-- <button class="pagination-button" (click)="nextPage()" [disabled]="currentPage === totalPages">
                    <svg viewBox="0 0 24 24" fill="currentColor" height="20" width="20">
                        <path d="M8.59 16.59L13.17 12 8.59 7.41 10 6l6 6-6 6-1.41-1.41z"></path>
                    </svg>
                </button> -->
            </div>
        </div>

        
    </div>}
@else if (viewMode==='list') {
    <div  class="custom-tab-wrapper">

        @if(selectedTab===0){
            @if(isDataLoading){
                <div class="loader-pro">
                    <app-loader></app-loader>
                </div>
                }
              @else {
                @if(agentsList &&  agentsList.length > 0){
                    <app-app-agent-table-view [DisplayedColumns]="InsurerAgentColumns" [data]="agentsList" [AcessRole]="role" (openinsurerAgentEdit)="openeditForm($event)"  (confirmStatusUpdateTrue)="statusUpdateTrue($event)" (confirmStatusUpdateFalse)="statusUpdateFalse($event)"></app-app-agent-table-view>
                }
                @else {
                     <div class="custom-card">
                        <app-no-data-found></app-no-data-found>
                    </div>
                }

              }  
        }

         @if(selectedTab===1){
            @if(isDataLoading){
                <div class="loader-pro">
                    <app-loader></app-loader>
                </div>
                }
              @else {
                @if(agentsList &&  agentsList.length > 0){
                    <app-app-agent-table-view [DisplayedColumns]="providerAgentColumns" [data]="agentsList" [AcessRole]="role" (openinsurerAgentEdit)="openeditForm($event)"  (confirmStatusUpdateTrue)="statusUpdateTrue($event)" (confirmStatusUpdateFalse)="statusUpdateFalse($event)"></app-app-agent-table-view>
                }
                @else {
                     <div class="custom-card">
                        <app-no-data-found></app-no-data-found>
                    </div>
                }

              }  
        }

         @if(selectedTab===2){
            @if(isDataLoading){
                <div class="loader-pro">
                    <app-loader></app-loader>
                </div>
                }
              @else {
                @if(distributorList &&  distributorList.length > 0){
                    <app-app-agent-table-view  [data]="distributorList" [DisplayedColumns]="DistributorAgentColumns" [AcessRole]="role" (openinsurerAgentEdit)="openeditForm($event)"  (confirmStatusUpdateTrue)="statusUpdateTrue($event)" (confirmStatusUpdateFalse)="statusUpdateFalse($event)"></app-app-agent-table-view>
                }
                @else {
                     <div class="custom-card">
                        <app-no-data-found></app-no-data-found>
                    </div>
                }

              }  
        }
       <div class="pagination-controls" >
                 <span>Pages :</span> 
                <!-- <button class="pagination-button" (click)="previousPage()" [disabled]="currentPage === 1">
                    <svg viewBox="0 0 24 24" fill="currentColor" height="20" width="20">
                        <path d="M15.41 16.59L10.83 12l4.58-4.59L14 6l-6 6 6 6 1.41-1.41z"></path>
                    </svg>
                </button> -->


                 <button *ngFor="let page of [].constructor(totalPages); let i = index" (click)="goToPage(i + 1)"
                [ngClass]="{ 'active': currentPage === i + 1 }" class="pagination-btn">
                {{ i + 1 }} 
            </button>
                <!-- <span class="fs-13">{{ currentPage }} / {{ totalPages }}</span>
                <button class="pagination-button" (click)="nextPage()" [disabled]="currentPage === totalPages">
                    <svg viewBox="0 0 24 24" fill="currentColor" height="20" width="20">
                        <path d="M8.59 16.59L13.17 12 8.59 7.41 10 6l6 6-6 6-1.41-1.41z"></path>
                    </svg>
                </button> -->
            </div>

    </div>}


</div>